import React from 'react';
import { Modal, Form, Input, Select, Button } from 'antd';

const STATUS_OPTIONS = [
  { value: true, label: 'Active' },
  { value: false, label: 'Inactive' },
];

export default function UserCreateModal({
  open,
  onCancel,
  form,
  onSubmit,
  submitLoading,
  roleOptions,
}) {
  return (
    <Modal
      title="Create user"
      open={!!open}
      onCancel={onCancel}
      footer={[
        <Button
          key="ok"
          type="primary"
          onClick={onSubmit}
          loading={submitLoading}
          className="app-btn-primary"
        >
          Create user
        </Button>,
        <Button key="cancel" onClick={onCancel} className="app-btn-cancel">
          Cancel
        </Button>,
      ]}
      destroyOnClose
      width={420}
      className="user-list-modal"
    >
      <Form form={form} layout="vertical" className="user-list-form-in-modal">
        <Form.Item
          name="name"
          label="Name"
          rules={[{ required: true, message: 'Required' }]}
        >
          <Input placeholder="Full name" />
        </Form.Item>
        <Form.Item
          name="email"
          label="Email"
          rules={[
            { required: true, message: 'Required' },
            { type: 'email', message: 'Invalid email' },
          ]}
        >
          <Input type="email" placeholder="email@example.com" />
        </Form.Item>
        <Form.Item
          name="password"
          label="Password"
          rules={[{ required: true, message: 'Required' }, { min: 6, message: 'Min 6 characters' }]}
        >
          <Input.Password placeholder="Password" />
        </Form.Item>
        <Form.Item name="roles" label="Roles" initialValue={['read-only']}>
          <Select
            mode="multiple"
            placeholder="Select roles"
            options={roleOptions}
            allowClear
          />
        </Form.Item>
        <Form.Item name="status" label="Status" initialValue={true}>
          <Select
            placeholder="Status"
            options={STATUS_OPTIONS}
            allowClear={false}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
}
